import { useState } from 'react';
import { Post } from '../../Axios/AxiosFunctions';
import Button from '../../Component/Button/Button';
import Input from '../../Component/Input/Input';
import { BaseURL } from '../../config/apiUrl';
import { apiHeader } from '../../config/apiUrl';
import { useNavigate } from 'react-router-dom';
import { IoMdArrowRoundForward } from 'react-icons/io';
import validator from 'validator';
import classes from './ForgotPassword.module.css';
import { toast } from 'react-toastify';
import { Container } from 'react-bootstrap';
import Header from '../../Component/Header';
import Footer from '../../Component/Footer';

function ForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!validator.isEmail(email)) {
      toast.warn('Please enter a valid email.');
      return; // Prevent further execution if email is invalid
    }

    setLoading(true);

    try {
      const response = await Post(BaseURL(`users/forgotPassword`), { email }, apiHeader(null));

      if (response) {
        toast.success('Verification code has been sent to your email.');
        navigate(`/verify-otp?email=${email}`);
      }
    } catch (error) {
      toast.error('Failed to send reset password link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <Container className={classes.container}>
        <div className={classes.main}>
          <h1 className={classes.title}>Forgot Password</h1>
          <p className={classes.subtitle}>
            Don&apos;t worry, it happens to everyone! Click on the &apos;Forgot Password&apos; link
            and we&apos;ll help you reset it.
          </p>
          <div className={classes.form}>
            <Input
              setValue={setEmail}
              value={email}
              placeholder={'Email *'}
              className={classes.input}
              noBorder={true}
            />
            <Button
              disabled={loading}
              loading={loading}
              label={loading ? 'Sending Reset Password Link...' : 'Send Reset Password Link'}
              onClick={handleSubmit}
              rightIcon={
                <span className={classes.icon}>
                  <IoMdArrowRoundForward />
                </span>
              }
              className={classes.button}
            />
          </div>
        </div>
      </Container>
      <Footer />
    </div>
  );
}

export default ForgotPassword;
